/**
 * Pinned enterprise teams — quick access in the enterprise dashboard sidebar.
 * Persisted per enterprise in localStorage (no backend). Scoped to current browser.
 */

const STORAGE_PREFIX = 'velox_ent_pinned_teams_';
export const PINNED_TEAMS_CHANGED_EVENT = 'velox-ent-pinned-teams-changed';

function storageKey(enterpriseId) {
  return `${STORAGE_PREFIX}${enterpriseId || ''}`;
}

/**
 * @param {string} enterpriseId
 * @returns {{ teamId: string, name: string }[]}
 */
export function getPinnedTeams(enterpriseId) {
  try {
    const raw = localStorage.getItem(storageKey(enterpriseId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((p) => p && typeof p.teamId === 'string' && p.teamId)
      : [];
  } catch {
    return [];
  }
}

/**
 * @param {string} enterpriseId
 * @param {{ teamId: string, name: string }[]} list
 */
export function setPinnedTeams(enterpriseId, list) {
  const safe = (list || []).filter((p) => p && typeof p.teamId === 'string');
  try {
    localStorage.setItem(storageKey(enterpriseId), JSON.stringify(safe));
    window.dispatchEvent(new CustomEvent(PINNED_TEAMS_CHANGED_EVENT, { detail: { enterpriseId } }));
  } catch (e) {
    console.warn('enterprisePinnedTeams: setPinnedTeams failed', e);
  }
}

/**
 * @param {string} enterpriseId
 * @param {string} teamId
 * @param {string} name
 */
export function addPin(enterpriseId, teamId, name) {
  const list = getPinnedTeams(enterpriseId);
  if (list.some((p) => p.teamId === teamId)) return;
  setPinnedTeams(enterpriseId, [...list, { teamId, name: String(name || 'Team').trim() || 'Team' }]);
}

/**
 * @param {string} enterpriseId
 * @param {string} teamId
 */
export function removePin(enterpriseId, teamId) {
  const list = getPinnedTeams(enterpriseId).filter((p) => p.teamId !== teamId);
  setPinnedTeams(enterpriseId, list);
}

/**
 * @param {string} enterpriseId
 * @param {string} teamId
 * @returns {boolean}
 */
export function isPinned(enterpriseId, teamId) {
  return getPinnedTeams(enterpriseId).some((p) => p.teamId === teamId);
}
